import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

type UpdateLeadLinkProps = {
    id: string
    dealerUserId?: string
    salesPersonId?: string
}

export async function updateLeadLink({
    id,
    dealerUserId,
    salesPersonId,
}: UpdateLeadLinkProps) {
    const requestBody = {
        salesperson_id: salesPersonId,
        dealer_user_id: dealerUserId,
    }

    try {
        await axios.post(
            `${config.API_BASE_URL}/api/v3/client-application/${id}/update_dealer_assigned_application/`,
            requestBody,
            {
                withCredentials: true,
            },
        )

        return true
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to update dealer assigned application: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}

export async function unassignLeadLink({ id }: UpdateLeadLinkProps) {
    try {
        await axios.post(
            `${config.API_BASE_URL}/api/v3/client-application/${id}/unassign_dealer_assigned_application/`,
            undefined,
            {
                withCredentials: true,
            },
        )

        return true
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to update dealer assigned application: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}
